import { Injectable } from "@angular/core";
import { API_METHODS, API_URL, OperationType } from "common/constants/sm-constants";
import { environment } from "src/environments/environment";
import { TypesModel } from "common/models/page-models/types/types-data-model";
import { FormDataService } from "../../base-data-services/form-data.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";



@Injectable({
    providedIn: 'root'
})
export class TypesFormDataService extends FormDataService<TypesModel> {

    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.addType, http, ss);
    }

    override getEditUrlAndMethod(id) {
        const edit = {
            url: environment.apiUrl + API_URL.viewTypes,
            method: API_METHODS.post,

        }
        return edit;
    }


    override getUpdatePayload(data: any) {
        console.log(data);
        
        let payload = {
            id: data.id
        }

        return payload
    }


    // override modifyAPIResponse(response: any) {
    //     // return response['detail']['cat'];

    //     const dataModel = this.createInstance();
    //     console.log(response.details.id, 'detail')
    //     dataModel.typeId = response.details.id;
    //     dataModel.type_name = response?.details?.type_name;
    //     dataModel.categories = response?.details?.categoryCount;
    //     return dataModel;
    // }

    createInstance(): TypesModel {
        return new TypesModel();
    }

    // override getStatusUrl(): string {
    //     return '/categoryNew/updateCategoryStatus';
    // }

    // override transformModel(model, metamodel: any = null): any {
    //  console.log(model);
    //     const formData = new FormData();
    //     console.log(model,'transformModel')
    //     return model;
    // }


    // override beforePostData(
    //     model: any,
    //     metamodel: any,
    //     dataModel: any
    // ): Promise<TypesModel> {
    //     return new Promise<any>((resolve, reject) => {
    //         const filteredCat = model.categories.filter(item => item.isPreFilled === false && item?.catName !== '');

    //         const updatedData = {
    //             ...model,
    //             categories: filteredCat
    //         };

    //         resolve(updatedData);
    //     });
    // }

    override beforePostData(
        model: any,
        metamodel: any,
        dataModel: any
    ): Promise<TypesModel> {
        return new Promise<any>((resolve, reject) => {
            // console.log(model);

            const categoryNames = model.categoryCount
            .filter(item => item.isPreFilled === false && item?.categories)  // Filter out items that are prefilled or have empty categories
            .map(item => item.categories);

             const postObject=
             {
                "type_name": model.type_name,
                "categories":categoryNames
             }
            // const filteredCat = model.categoryCount.filter(item => item.isPreFilled === false && item?.categories !== '');

            // const updatedData = {
            //     ...model,
            //     categories: filteredCat
            // };

            if (model.id) {
                postObject['id'] = model.id;
            }

            resolve(postObject);
        });
    }


    override getUpdateUrl() {

        return API_URL.editType;
    }


    override getOperationType(data: any) {
        // console.log(data,'data')
        if (data.hasOwnProperty('typeId')) {
            return (data.typeId !== '' && data.typeId !== null) ? OperationType.UPDATE : OperationType.CREATE;
        } else {
            return OperationType.CREATE;
        }
    }

    override updatepostUrl() {
        return environment.apiUrl + API_URL.editType;
    }


    override async postData(data: any): Promise<any> {
        return await super.postData(data, false);
    }

}

export { FormDataService };
